import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ModulePage from "./ModulePage";
import Module from "./module/Module";
import { getModuleBySlug } from "../../api/subjects";

const DbModuleRuntimePage = ({ userName, userRoles }) => {
    const { id, subject, author, moduleSlug } = useParams();
    const [moduleData, setModuleData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let mounted = true;

        async function load() {
            if (!id || !subject || !author || !moduleSlug) return;
            setLoading(true);
            try {
                const data = await getModuleBySlug(id, subject, author, moduleSlug);
                if (!mounted) return;

                setModuleData({
                    title: data?.title || "",
                    questions: Array.isArray(data?.questions) ? data.questions : [],
                    pdfPath: data?.pdfPath || null,
                    pdfFileName: data?.pdfFileName || null,
                });
            } catch (e) {
                if (mounted) setModuleData(null);
            } finally {
                if (mounted) setLoading(false);
            }
        }

        load();
        return () => {
            mounted = false;
        };
    }, [id, subject, author, moduleSlug]);

    if (loading) return null;

    if (!moduleData) {
        return (
            <ModulePage
                component={() => <div className="placeholder-content"><p>Модуль не знайдено або він без контенту</p></div>}
                module={{ title: "", questions: [] }}
                userName={userName}
                userRoles={userRoles}
            />
        );
    }

    return (
        <ModulePage
            component={Module}
            module={moduleData}
            userName={userName}
            userRoles={userRoles}
        />
    );
};

export default DbModuleRuntimePage;
